import React from 'react';
import style from './componentCss/ScrollEventComponent.module.css';
import { useInView } from 'react-intersection-observer';

const ScrollEventComponent = ({
  children,
  type = 'scroll_up',
  threshold = 0.3,
  triggerOnce = true,
  delay = 0
}) => {
  const { ref, inView } = useInView({
    threshold,
    triggerOnce,
    delay
  });

  const className = `${style.scroll_up_wrapper} ${inView ? style[type] : ''}`;

  return (
    <div ref={ref} className={className}>
      {children}
    </div>
  );
};

export default ScrollEventComponent;
